module.exports = __webpack_public_path__ + "static/SharpSansNo1-Semibold-5fc5656fe10b365f212a90fcaee29bfc.woff2";